import React, { useEffect, useRef, useState } from "react";
import "./askChat.scss";
import { X, ChevronDown, Send } from "lucide-react";
import RadioButton from "../../../../components/RadioButton/RadioButton";

const AskChat = () => {
  const askChat = [
    "Where are Wriver?",
    "What’s the best way?",
    // "Does Wriver customize furniture for my home or office?",
    "How can I get design consultation from Wriver?",
  ];
  const chatBodyRef = useRef(null);
  const [openChat, setOpenChat] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [botTyping, setBotTyping] = useState(false);

  const handleRadioClick = (q) => {
    setOpenChat(true);
    setCollapsed(false);

    // user message
    setMessages([...messages, { from: "user", text: q }]);

    // Bot typing start
    setBotTyping(true);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "Thank you! Our team will assist shortly." },
      ]);
      setBotTyping(false);
    }, 1000); // 1 second typing animation
  };

  const sendMessage = () => {
    if (!input.trim()) return;

    // user message
    setMessages([...messages, { from: "user", text: input }]);

    setBotTyping(true);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "Message received!" },
      ]);
      setBotTyping(false);
    }, 1000);

    setInput("");
  };

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTo({
        top: chatBodyRef.current.scrollHeight,
        behavior: "smooth", //smooth scroll
      });
    }
  }, [messages]); //scroll when message changes

  return (
    <>
      <div className="ask_chat--wrapper">
        <div className="title--chat">Ask Wriver</div>

        <ul className="list_ul--chat">
          {askChat.map((radio, index) => (
            <div key={index} onClick={() => handleRadioClick(radio)}>
              <RadioButton
                label={radio}
                labelId={`radio-${index}`}
                lightTheme
                disabled={true}
              />
            </div>
          ))}

          {/* Extra option */}
          <div
            key="ask-something-else"
            onClick={() => {
              setOpenChat(true);
              setCollapsed(false);
              // messages empty
            }}
            className="active_radio"
          >
            <RadioButton
              label="Ask something else"
              labelId="radio-else"
              lightTheme
              // disabled={true}
            />
          </div>
        </ul>

        {openChat && (
          <div className={`chat_box ${collapsed ? "collapsed" : ""}`}>
            <div
              className="chat_header"
              onClick={() => setCollapsed(!collapsed)}
            >
              <span className="heading_chat_box">Ask Wriver</span>

              <div className="icons">
                <ChevronDown className={collapsed ? "rotate" : ""} />
                <X
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenChat(false);
                  }}
                />
              </div>
            </div>

            <div className="chat_collapse">
              <div className="chat_body" ref={chatBodyRef}>
                
                {messages.map((m, i) => (
                  <div key={i} className={`msg ${m.from}`}>
                    {m.text}
                  </div>
                ))}

                {botTyping && (
                  <div className="msg bot typing">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                )}
              </div>

              <div className="chat_footer">
                <input
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Ask anything..."
                />
                <button onClick={sendMessage}>
                  <Send size={16} />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AskChat;
